(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class RelativeHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.dropdowns = this.querySelectorAll("details.site-header__label");
    this.setupListener();
  }

  setupListener() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.querySelector("summary").addEventListener('click', this.updateActiveDialog.bind(this));
    });
  }

  updateActiveDialog(e) {
    let thisDropdown = e.target.parentNode;

    // Close all other dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown !== thisDropdown) {
        dropdown.removeAttribute("open");
      }
    });

    // Toggle header class based on dropdown state
    if (thisDropdown.hasAttribute("open")) {
      if (!thisDropdown.classList.contains('__scroll')) {
        window.SnowcubesScrollLock?.unlock(this);
      }
      this.header.classList.remove('__dropdown-open');
    } else {
      if (!thisDropdown.classList.contains('__scroll')) {
        window.SnowcubesScrollLock?.lock(this);
      }
      this.header.classList.add('__dropdown-open');
    }
  }
}

customElements.define('relative-header', RelativeHeader);

class StickyHeader extends RelativeHeader {
  constructor() {
    super();
    this.lastScrollTop = 0; // Initialize last scroll position
    document.addEventListener('scroll', this.updateClass.bind(this));
  }

  updateClass() {
    // A scroll lock pins the page at scrollY 0 without the shopper scrolling;
    // reacting would move the header (and its open dropdown) off-screen.
    if (document.body.classList.contains('__mobile-overflow-none')) return;

    let currentScrollTop = window.pageYOffset;
    let alwaysShowNav = this.classList.contains('__always-show-nav');
    let scrollingDown = currentScrollTop > this.lastScrollTop;

    // Update last scroll position
    this.lastScrollTop = currentScrollTop;

    // Add or remove the `__hidden` class based on scroll direction
    if (scrollingDown && !alwaysShowNav && currentScrollTop > 0 && window.innerWidth >= 1200) {
      this.classList.add('__hidden');
    } else {
      this.classList.remove('__hidden');
    }

    // Ensure the header is always in the correct state
 
    if(currentScrollTop <=200 && !scrollingDown){
      this.classList.add('__relative');
    }
   else if (currentScrollTop <= 0) {
      this.classList.add('__relative');
    } else {
      this.classList.remove('__relative');
    }
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
